import { MainContent, TopBar } from '@domain-group/suit-theme'

import LoggedInUser from '@components/LoggedInUser'

import MainNavigation from '@sections/Admin/components/MainNavigation'

import useMainNavigation from '@hooks/useMainNavigation'

import AutoOrderQueuesRoutes from './routes'

const AutoOrderQueues = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        searchComponent={<TopBar.Search callbacks={{ search: null }} />}
      />

      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <AutoOrderQueuesRoutes />
      </MainContent>
    </>
  )
}

export default AutoOrderQueues
